import { promisify } from "./utils/Promisify";

function convertToBase64FnDescriptor(data: string, type: string) {
  return {
    type: "CONVERT_TO_BASE64" as const,
    payload: { data, type },
  };
}

export type TConvertToBase64Args = Parameters<typeof convertToBase64FnDescriptor>;
export type TConvertToBase64Description = ReturnType<typeof convertToBase64FnDescriptor>;
export type TConvertToBase64ActionType = TConvertToBase64Description["type"];

async function convertToBase64(...args: Parameters<typeof convertToBase64FnDescriptor>) {
  return promisify(convertToBase64FnDescriptor)(...args);
}

export default convertToBase64;